import "./Login.css";
import { useRef, useState, useEffect } from "react";
import "./Register.css";
import { ReactComponent as Arrow } from "../assets/arrow.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { auth, firestore } from "../firebase/firebaseConfig";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useIsMobile } from "../hooks/useIsMobile";

function Login({ signUp }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [emailExists, setEmailExists] = useState(true);
  const [emailBeingChecked, setEmailBeingChecked] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [x, setX] = useState(0);
  const [currentRef, setCurrentRef] = useState(null);
  const [signingIn, setSigningIn] = useState(false);
  const [resetMailSent, setResetMailSent] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (currentRef)
      setTimeout(() => {
        currentRef.current.focus();
      }, 500);
  }, [x]);

  const checkIfEmailExists = async () => {
    setEmailBeingChecked(true);
    try {
      const q = query(
        collection(firestore, "users"),
        where("email", "==", email)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setEmailBeingChecked(false);
        setCurrentRef(passwordRef);
        setX(x + 1);
      } else {
        setEmailBeingChecked(false);
        setEmailExists(false);
      }
    } catch (error) {
      setEmailBeingChecked(false);
    }
  };

  const signIn = async () => {
    setSigningIn(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      setSigningIn(false);
      navigate(0);
    } catch (error) {
      console.log(error.message);
      setWrongPassword(true);
      setSigningIn(false);
    }
  };

  const sendResetMail = async () => {
    setResetMailSent(true);
    sendPasswordResetEmail(auth, email);
  };

  return (
    <div className="login">
      <p className="title">Log In</p>
      <div className="email" style={{ transform: `translateX(-${100 * x}%)` }}>
        <p>E-Mail</p>
        <div
          style={{
            height: isMobile ? "40px" : "50px",
            width: isMobile ? "90%" : "35%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Logo
            className="email-checking"
            style={{
              width: "10%",
              height: "100%",
              filter: "drop-shadow(0px 0px 10px white)",
              display: !emailBeingChecked && "none",
            }}
          ></Logo>
          <input
            type="text"
            inputMode="text"
            value={email}
            onChange={(e) => {
              setEmail(e.currentTarget.value);
              if (!emailExists) setEmailExists(true);
            }}
            onKeyDown={(e) => {
              if (!emailBeingChecked && e.key === "Enter") {
                checkIfEmailExists();
              }
            }}
            ref={emailRef}
          ></input>
          <div
            className="next-button"
            onClick={() => {
              if (!emailBeingChecked) {
                checkIfEmailExists();
              }
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
        </div>
        <div className="error" style={{ display: emailExists && "none" }}>
          • Email is not signed in!
        </div>
        <p style={{ fontSize: isMobile ? "15px" : "25px" }}>
          Create new Account?{" "}
          <span
            className="sign-up-link"
            onClick={() => {
              signUp();
            }}
          >
            Sign up
          </span>
        </p>
      </div>
      <div
        className="password"
        style={{ transform: `translateX(-${100 * x}%)` }}
      >
        <p>Password</p>
        <div
          style={{
            height: isMobile ? "40px" : "50px",
            width: isMobile ? "90%" : "35%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            className="previous-button"
            onClick={() => {
              setCurrentRef(emailRef);
              setX(x - 1);
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
          <Logo
            className="email-checking"
            style={{
              width: "10%",
              height: "100%",
              filter: "drop-shadow(0px 0px 10px white)",
              display: !signingIn && "none",
            }}
          ></Logo>
          <input
            value={password}
            onChange={(e) => {
              setPassword(e.currentTarget.value);
              if (wrongPassword) setWrongPassword(false);
            }}
            type="password"
            inputMode="text"
            ref={passwordRef}
            onKeyDown={(e) => {
              if (!signingIn && e.key === "Enter") {
                signIn();
              } else if (e.key === "Backspace" && password.length === 0) {
                setCurrentRef(emailRef);
                setX(x - 1);
              }
            }}
          ></input>
          <div
            className="next-button"
            onClick={() => {
              if (!signingIn) signIn();
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
        </div>
        <div className="error" style={{ display: !wrongPassword && "none" }}>
          • Wrong Password!
        </div>
        <p style={{ fontSize: isMobile ? "15px" : "25px" }}>
          Forgot your password?{" "}
          {!resetMailSent ? (
            <span
              className="reset-pw-link"
              onClick={() => {
                sendResetMail();
              }}
            >
              Reset Password
            </span>
          ) : (
            <span>Mail has been sent!</span>
          )}
        </p>
      </div>
    </div>
  );
}

export default Login;
